document.addEventListener('DOMContentLoaded', function () {
  const countdownSection = document.querySelector('.m-countdown-section');
  if (!countdownSection) return;

  // Lightning flash
  const flash = document.createElement('div');
  flash.className = 'celebration-flash';
  countdownSection.appendChild(flash);

  // Confetti canvas
  const canvas = document.createElement('canvas');
  canvas.className = 'confetti-canvas';
  countdownSection.appendChild(canvas);
  const ctx = canvas.getContext('2d');

  function resizeCanvas() {
    canvas.width  = countdownSection.offsetWidth;
    canvas.height = countdownSection.offsetHeight;
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  const COLORS = ['#B2D4CC', '#2d6a4f', '#f4d35e', '#ee6c4d', '#ffffff', '#ffb4a2', '#c9b8e8', '#ffd6a5'];
  const particles = [];

  function rand(a, b) { return a + Math.random() * (b - a); }

  function spawnBurst(count, fromTop) {
    for (let i = 0; i < count; i++) {
      const shape = Math.random();
      particles.push({
        x:         rand(0, canvas.width),
        y:         fromTop ? rand(-20, -5) : rand(canvas.height * 0.1, canvas.height * 0.4),
        r:         rand(5, 11),
        color:     COLORS[Math.floor(Math.random() * COLORS.length)],
        speedY:    rand(1.0, 3.5),
        speedX:    rand(-1.5, 1.5),
        wobble:    rand(0, Math.PI * 2),
        wobbleSpd: rand(0.03, 0.12),
        tilt:      rand(-0.8, 0.8),
        shape:     shape < 0.4 ? 'rect' : shape < 0.7 ? 'circle' : 'star',
        opacity:   1,
        fadeSpeed: rand(0.003, 0.007),
      });
    }
  }

  function drawStar(ctx, r) {
    const spikes = 5;
    const outerR = r;
    const innerR = r / 2.5;
    let rot = (Math.PI / 2) * 3;
    const step = Math.PI / spikes;
    ctx.beginPath();
    for (let i = 0; i < spikes; i++) {
      ctx.lineTo(Math.cos(rot) * outerR, Math.sin(rot) * outerR);
      rot += step;
      ctx.lineTo(Math.cos(rot) * innerR, Math.sin(rot) * innerR);
      rot += step;
    }
    ctx.closePath();
    ctx.fill();
  }

  // Big burst on load when section is visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        spawnBurst(50, false);
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });
  observer.observe(countdownSection);

  let frame = 0;
  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    frame++;
    if (frame % 22 === 0) spawnBurst(3, true);
    if (frame % 100 === 0) spawnBurst(15, true);

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.y       += p.speedY;
      p.x       += p.speedX + Math.sin(p.wobble) * 1.5;
      p.wobble  += p.wobbleSpd;
      p.opacity -= p.fadeSpeed;

      if (p.y > canvas.height || p.opacity <= 0) {
        particles.splice(i, 1);
        continue;
      }

      ctx.save();
      ctx.globalAlpha = Math.max(0, p.opacity);
      ctx.fillStyle   = p.color;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.tilt + p.wobble * 0.25);

      if (p.shape === 'rect') {
        ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 2.2);
      } else if (p.shape === 'circle') {
        ctx.beginPath();
        ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        drawStar(ctx, p.r / 2);
      }
      ctx.restore();
    }

    requestAnimationFrame(animate);
  }

  animate();
});